import request from '@/utils/request'

export function getProfile() {
  return request({ url: '/backendUser/profile', method: 'post' })
}

export function updateProfile(data) {
  return request({ url: '/backendUser/updateProfile', method: 'post', data })
}

export function changePassword(data) {
  return request({ url: '/backendUser/changePassword', method: 'post', data })
}

export function uploadAvatar(data) {
  return request({
    url: '/backendUser/uploadAvatar',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}
